import * as React from 'react';
import { Col, Row, Divider, Input, Select, Checkbox } from 'antd';

import Form, { FormItem, ColorInput } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface IOrderStateDetailProps {
  domain: string;
  orderState: GQL.IExternalOrderState;
  languages: Array<GQL.ILanguage>;
  onSave: (orderState: GQL.IExternalOrderState) => void;
  onCancel: () => void;
}

interface IOrderStateDetailState {
  orderState: GQL.IExternalOrderState;
  currentLanguage: string;
}

export default class OrderStateDetail extends React.Component<IOrderStateDetailProps, IOrderStateDetailState> {

  public constructor(props: IOrderStateDetailProps) {
    super(props);

    this.state = {
      orderState: props.orderState || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { orderState, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={this.state.currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {orderState
            ? `Order state ${orderState.title ? `"${orderState.title}"` : ''}`
            : `Order states`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24}>
              <FormItem label={'Title'} required={true}>
                <Input
                  name={'title'}
                  autoFocus={true}
                  required={true}
                  placeholder="Internal title. For example &quot;Ceska posta - balik do ruky&quot;"
                  addonBefore={'Internal'}
                  defaultValue={orderState.title || ''}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem label={'Name'} required={true}>
                <Input
                  key={currentLanguage}
                  name={'name'}
                  required={true}
                  addonBefore={currentLanguage}
                  placeholder="OrderState's name in eshop"
                  defaultValue={(orderState.name || {})[currentLanguage]}
                  onChange={e => this.onChange(e, currentLanguage)}
                />
              </FormItem>
              <FormItem label={'Priority'}>
                <Input
                  name={'priority'}
                  type={'number'}
                  defaultValue={(orderState.priority || '').toString()}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem label={'Type'} required={true}>
                <Select
                  style={{ width: '100%' }}
                  onChange={(value: string) => this.onChange({ target: { name: 'type', value } })}
                  placeholder="Type"
                  defaultValue={orderState.type || 'info'}
                >
                  <Select.Option key={'info'} value={'info'}>
                    Info
                  </Select.Option>
                  <Select.Option key={'warning'} value={'warning'}>
                    Warning
                  </Select.Option>
                  <Select.Option key={'danger'} value={'danger'}>
                    Danger
                  </Select.Option>
                </Select>
              </FormItem>
              <FormItem label={'Color'} extra={'Internal color highlighting orders for backoffice'}>
                <ColorInput
                  name={'color'}
                  value={orderState.color || ''}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'startup'}
                  checked={orderState.startup !== null && orderState.startup !== undefined ? orderState.startup : false}
                  onChange={e => this.onChange(e)}
                >
                  Startup
                </Checkbox>
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'forPaidOrder'}
                  checked={orderState.forPaidOrder !== null && orderState.forPaidOrder !== undefined ? orderState.forPaidOrder : false}
                  onChange={e => this.onChange(e)}
                >
                  For paid orders
                </Checkbox>
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'forSentOrder'}
                  checked={orderState.forSentOrder !== null && orderState.forSentOrder !== undefined ? orderState.forSentOrder : false}
                  onChange={e => this.onChange(e)}
                >
                  For sent orders
                </Checkbox>
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'setOrderAsPaid'}
                  checked={orderState.setOrderAsPaid !== null && orderState.setOrderAsPaid !== undefined ? orderState.setOrderAsPaid : false}
                  onChange={e => this.onChange(e)}
                >
                  Set order as paid
                </Checkbox>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.orderState[name], [language]: inputValue } }
      : { [name]: inputValue });
    this.setState({
      orderState: { ...this.state.orderState, ...newValue }
    });
  }

  private async save() {
    const orderState = { ...this.state.orderState };
    this.props.onSave(orderState);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderStates/OrderStateDetail/OrderStateDetail.tsx